var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInputError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 5.5,
  fill: "#EB5757",
  stroke: "#EB5757"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FDFDFD",
  d: "M6 3.5v3m0 1v1"
})));
export default SvgInputError;